"use client"
import { useTheme } from "@mui/material/styles"
import { FC } from "react"

import styles from "./PostHeaderReadCount.module.scss"
import { PostHeaderSeperator } from "./PostHeaderSeperator"

import { Icon } from "@/components/common/icon"

import { create } from "@/helpers/bem"

const bem = create(styles, "PostHeaderReadCount")

export type PostHeaderReadCountProps = {
  readCount?: number
}

export const PostHeaderReadCount: FC<PostHeaderReadCountProps> = ({
  readCount,
}) => {
  const theme = useTheme()
  const themeModifier = {
    [theme.palette.mode]: true,
  }
  if (!readCount || readCount === 0) return null
  return (
    <div
      itemScope
      className={bem(undefined, themeModifier)}
      itemProp="interactionStatistic"
      itemType="https://schema.org/InteractionCounter"
    >
      <PostHeaderSeperator />
      <Icon className={bem("icon")} name="Eye" size="sm" />
      <meta
        content="https://schema.org/ReadAction"
        itemProp="interactionType"
      />
      <span itemProp="userInteractionCount">{readCount}</span>
    </div>
  )
}
